import React from 'react';
import { Link } from 'react-router-dom';

// SEOManager already sets a noindex robots meta and "Page Not Found" title for
// any path without an SEO config, so this component only renders the visible
// 404 state.
const NotFoundPage = () => (
  <div className="min-h-screen pt-32 pb-20 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <h1 className="text-5xl font-bold mb-6">Page Not Found</h1>
      <p className="text-gray-400 mb-8">
        The page you are looking for doesn&apos;t exist or may have moved.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4">
        <Link to="/" className="btn-primary px-8 py-4 rounded-full inline-block">
          Back to Home
        </Link>
        <Link
          to="/shop"
          className="px-8 py-4 rounded-full inline-block border border-gray-700 hover:border-gray-500 transition"
        >
          Shop ClearWay
        </Link>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
